export default __webpack_public_path__ + "static/media/787 04222022.a6861d07.jpg";